import React, { useContext, useState, useEffect, useRef } from 'react';
import { Badge, Tooltip, Box, Icon, ListItem, List, ListItemButton, ListItemIcon, Divider, ListItemText, Dialog, DialogTitle, DialogActions } from "@mui/material";
import Button from '@mui/material/Button';
import { NavLink } from "react-router-dom";
import classes from './NavigationModulos.module.css';
import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';
import LogoutIcon from '@mui/icons-material/Logout';
import CloseIcon from '@mui/icons-material/Close';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Slide from '@mui/material/Slide';
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function DataMenu({ texto, handlMenu, x, moss, cerrar, HandleLogout, abierto, unreadMessages }) {
    return (
        <>

            {
                texto.length <= 1 && (
                    <MenuLeveOne text={texto[0]} parrent={texto[0][4]} cerrar={cerrar} HandleLogout={HandleLogout} abierto={abierto} />
                )
            }

            {
                true && (
                    <>
                        <Modulo text={texto} handleSubmenus={handlMenu} xx={x} mos={moss} cerrar={cerrar} abierto={abierto} unreadMessages={unreadMessages} />
                    </>
                )

            }

        </>
    );
}

function Modulo({ text, handleSubmenus, xx, moss, cerrar, abierto, unreadMessages }) {

    return (
        <>
            <>

                <ListItem key={text.modulo + Math.random()} disablePadding sx={{ display: 'block' }}>
                    {abierto === false ? (
                        <Tooltip title={text.modulo} placement='right'>
                            <ListItemButton className={classes.modul}
                                onClick={() => handleSubmenus(xx, -1)}
                                sx={{
                                    minHeight: 48,
                                    justifyContent: 'initial',
                                    px: 2.5,
                                }}>
                                {text.mostrar == true ? <Icon style={{ color: "grey" }}>{"keyboard_arrow_down"} </Icon> : <Icon style={{ color: "grey" }}>{"keyboard_arrow_right"} </Icon>}
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: 3,
                                        justifyContent: 'center',
                                    }}
                                >

                                    <Icon style={{ color: "grey" }}>{text.icono}</Icon>

                                </ListItemIcon>
                                <ListItemText primary={text.modulo} sx={{ opacity: 1, whiteSpace: 'normal' }} />
                            </ListItemButton>
                        </Tooltip>
                    ) : (
                        <ListItemButton className={classes.modul}
                            onClick={() => handleSubmenus(xx, -1)}
                            sx={{
                                minHeight: 48,
                                justifyContent: 'initial',
                                px: 2.5,
                            }}>
                            {text.mostrar == true ? <Icon style={{ color: "grey" }}>{"keyboard_arrow_down"} </Icon> : <Icon style={{ color: "grey" }}>{"keyboard_arrow_right"} </Icon>}
                            <ListItemIcon
                                sx={{
                                    minWidth: 0,
                                    mr: 3,
                                    justifyContent: 'center',
                                }}
                            >

                                <Icon style={{ color: "grey" }}>{text.icono}</Icon>

                            </ListItemIcon>

                            <ListItemText primary={text.modulo} sx={{ opacity: 1, whiteSpace: 'normal' }} />
                        </ListItemButton>
                    )}
                    {text.mostrar === true &&
                        <Box>
                            {text.permisos
                                .map((menuItem, index) => ({ menuItem, index }))
                                .filter(({ menuItem }) => menuItem.permiso !== "MenuPlanillas")
                                .map(({ menuItem, index }) => (
                                    <MenuLevelTwo key={menuItem.id || index} px={xx} i={index} text={menuItem} modulo={text.modulo} submenu={handleSubmenus} cerrar={cerrar} abierto={abierto} unreadMessages={unreadMessages} />
                                ))}
                        </Box>
                    }
                    <Divider color='white' />
                </ListItem>
            </>
        </>
    );
}

function MenuLeveOne({ text, parrent, cerrar, HandleLogout, abierto }) {
    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            {text[3] === 'Cerrar Sesión' ? (
                <>
                    <List
                        onClick={handleOpen}
                        className={({ isActive }) => isActive ? classes.nav : classes.navMenu}
                        style={{
                            textDecoration: 'none',
                            color: 'white'
                        }}
                    >
                        <ListItem disablePadding sx={{ display: 'block' }}>
                            <ListItemButton
                                onClick={handleOpen}
                                sx={{
                                    minHeight: 48,
                                    justifyContent: 'initial',
                                    px: 2.5,
                                }}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: 3,
                                        justifyContent: 'center',
                                    }}
                                >
                                    <LogoutIcon style={{ color: "white" }} />
                                </ListItemIcon>
                                <ListItemText primary={text[3]} sx={{ opacity: 1, whiteSpace: 'normal' }} />
                            </ListItemButton>
                            <Divider color='white' />
                        </ListItem>
                    </List>
                </>
            ) : (
                <>
                    {abierto === false ? (
                        <Tooltip title={text[3]} placement='right'>
                            <NavLink
                                to="/Inicio"
                                onClick={cerrar}
                                className={({ isActive }) => isActive ? classes.nav : classes.navMenu}
                                style={{
                                    textDecoration: 'none',
                                    color: 'white'
                                }}
                            >
                                <ListItem key={text[1] + text[3] + Math.random()} disablePadding sx={{ display: 'block' }}>
                                    <ListItemButton

                                        sx={{

                                            minHeight: 48,
                                            justifyContent: 'initial',
                                            px: 2.5,
                                        }}
                                    >
                                        <ListItemIcon
                                            sx={{

                                                minWidth: 0,
                                                mr: 3,
                                                justifyContent: 'center',

                                            }}
                                        >
                                            {text[3] === 'Dashboard' ? (
                                                <SpaceDashboardIcon style={{ color: "white" }} />
                                            ) : (
                                                text[3] === 'Cerrar Sesión' ? (
                                                    <LogoutIcon style={{ color: "white" }} />
                                                ) : (
                                                    <Icon style={{ color: "grey" }}>{text[0][5]}</Icon>
                                                )
                                            )
                                            }

                                        </ListItemIcon>

                                        <ListItemText primary={text[3]} sx={{ opacity: 1 }} />

                                    </ListItemButton>
                                    <Divider color='white' />
                                </ListItem>
                            </NavLink>
                        </Tooltip>
                    ) : (
                        <NavLink
                            to="/Inicio"
                            onClick={cerrar}
                            className={({ isActive }) => isActive ? classes.nav : classes.navMenu}
                            style={{
                                textDecoration: 'none',
                                color: 'white'
                            }}
                        >
                            <ListItem key={text[1] + text[3] + Math.random()} disablePadding sx={{ display: 'block' }}>
                                <ListItemButton

                                    sx={{

                                        minHeight: 48,
                                        justifyContent: 'initial',
                                        px: 2.5,
                                    }}
                                >
                                    <ListItemIcon
                                        sx={{

                                            minWidth: 0,
                                            mr: 3,
                                            justifyContent: 'center',

                                        }}
                                    >
                                        {text[3] === 'Dashboard' ? (
                                            <SpaceDashboardIcon style={{ color: "white" }} />
                                        ) : (
                                            text[3] === 'Cerrar Sesión' ? (
                                                <LogoutIcon style={{ color: "white" }} />
                                            ) : (
                                                <Icon style={{ color: "grey" }}>{text[0][5]}</Icon>
                                            )
                                        )
                                        }

                                    </ListItemIcon>
                                        <ListItemText primary={text[3]} sx={{ opacity: 1 }} />

                                    </ListItemButton>
                                    <Divider color='white' />
                            </ListItem>
                        </NavLink>
                    )}
                </>
            )}

            <Dialog open={open} onClose={handleClose} TransitionComponent={Transition}>
                <DialogTitle>{"¿Quiere cerrar la sesión?"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description" align='justify'>
                        ¿Está seguro que desea cerrar sesión? si lo hace será redirigido a la
                        pantalla de inicio de sesión y deberá ingresar sus credenciales nuevamente
                        para ingresar.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} variant='contained' startIcon={<CloseIcon />}>
                        Cancelar
                    </Button>
                    <Button onClick={HandleLogout} variant='contained' endIcon={<LogoutIcon />}>
                        Salir
                    </Button>
                </DialogActions>
            </Dialog>
        </>

    );
}

function MenuLevelTwo({ text, submenu, px, i, cerrar, abierto, unreadMessages, modulo }) {
    const hasChildren = text.subpermisos && text.subpermisos.length > 0;
    const label = text.detalle_permiso || text.permiso;

    const normalizeSegment = (value) => {
        if (!value) return "";
        return value
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .replace(/[^a-zA-Z0-9\s]/g, "")
            .trim()
            .replace(/\s+/g, "");
    };

    const getRoute = (moduloValue, item) => {
        const moduloSegment = normalizeSegment(moduloValue);
        const leafSegment = normalizeSegment(item.detalle_permiso || item.permiso);
        return `/${[moduloSegment, leafSegment].filter(Boolean).join("/")}`;
    };

    const content = (
        <ListItemButton
            className={classes.menuItem}
            onClick={hasChildren ? () => submenu(px, i) : cerrar}
            sx={{ minHeight: 48, justifyContent: 'initial', px: 4 }}
        >
            {hasChildren && (
                <Icon style={{ color: 'grey' }}>
                    {text.mostrar ? 'keyboard_arrow_down' : 'keyboard_arrow_right'}
                </Icon>
            )}
            <ListItemIcon sx={{ minWidth: 0, mr: 3, justifyContent: 'center' }}>
                <Icon style={{ color: 'grey' }}>{text.icono}</Icon>
            </ListItemIcon>
            <ListItemText primary={label} sx={{ opacity: 1, whiteSpace: 'normal' }} />
        </ListItemButton>
    );

    return (
        <ListItem className={classes.list} key={text.id} disablePadding sx={{ display: 'block' }}>
            {hasChildren ? (
                content
            ) : (
                <NavLink
                    to={getRoute(modulo, text)}
                    style={{ textDecoration: 'none', color: 'black' }}
                >
                    {content}
                </NavLink>
            )}

            {/* Sólo itero SUBPERMISOS, nunca el padre de nuevo */}
            {hasChildren && text.mostrar && (
                <Box>
                    {text.subpermisos.map(subItem => (
                        <SubmenuRecursive
                            key={subItem.id}
                            item={subItem}
                            nivel={3}
                            cerrar={cerrar}
                            abierto={abierto}
                            modulo={modulo}
                            trail={[label]}
                        />
                    ))}
                </Box>
            )}

            <Divider color='white' />
        </ListItem>
    );
}

function SubmenuRecursive({ item, nivel = 1, cerrar, abierto, modulo, trail = [] }) {
    const [open, setOpen] = useState(false);
    const hasChildren = item.subpermisos && item.subpermisos.length > 0;

    const toggleOpen = () => setOpen(!open);

    const normalizeSegment = (value) => {
        if (!value) return "";
        return value
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .replace(/[^a-zA-Z0-9\s]/g, "")
            .trim()
            .replace(/\s+/g, "");
    };

    const getRoute = (moduloValue, segments) => {
        const moduloSegment = normalizeSegment(moduloValue);
        const pathSegments = (segments || [])
            .filter(Boolean)
            .map((segment) => normalizeSegment(segment));
        return `/${[moduloSegment, ...pathSegments].join("/")}`;
    };

    const content = (
        <ListItemButton
            className={classes.submenuItem}
            onClick={hasChildren ? toggleOpen : cerrar}
            sx={{ minHeight: 44, px: nivel * 2 }}
        >
            {hasChildren && (
                <Icon style={{ color: "grey" }}>
                    {open ? "keyboard_arrow_down" : "keyboard_arrow_right"}
                </Icon>
            )}
            <ListItemIcon sx={{ minWidth: 0, mr: 2, justifyContent: 'center' }}>
                <Icon style={{ color: "grey" }}>{item.icono}</Icon>
            </ListItemIcon>
            <ListItemText primary={item.detalle_permiso} sx={{ whiteSpace: 'normal' }} />
        </ListItemButton>
    );

    return (
        <>
            <ListItem className={`${classes.listItemBase} ${classes['nivel' + nivel]}`} disablePadding>
                {hasChildren ? (
                    content
                ) : (
                    <NavLink
                        to={getRoute(modulo, [...trail, item.detalle_permiso])}
                        onClick={cerrar}
                        style={{ textDecoration: 'none', color: 'black' }}
                    >
                        {content}
                    </NavLink>
                )}
            </ListItem>

            {hasChildren && open && (
                <Box>
                    {item.subpermisos.map((subItem, index) => (
                        <SubmenuRecursive
                            key={subItem.permiso + index}
                            item={subItem}
                            nivel={nivel + 1}
                            cerrar={cerrar}
                            abierto={abierto}
                            modulo={modulo}
                            trail={[...trail, item.detalle_permiso]}
                        />
                    ))}
                </Box>
            )}
        </>
    );
}
